import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { Gift } from 'lucide-react';
export function ThreeBonus() {
  const bonuses = [{
    title: 'Kit Carta Lista',
    desc: 'Tu hoja de ruta personalizada con los datos clave del mapa natal de tu hijo en un solo lugar',
    value: '$15 USD'
  }, {
    title: 'Calma en 10',
    desc: '21 mantras de emergencia con audio para regularte vos primero antes de responderle',
    value: '$12 USD'
  }, {
    title: 'Mamá Traductora',
    desc: 'Guía rápida para descifrar qué te está diciendo realmente tu hijo con cada conducta',
    value: '$15 USD'
  }];
  return <SectionWrapper className="bg-burgundy text-white rounded-3xl my-12" data-id="element-279">
      <div className="text-center mb-16" data-id="element-280">
        <h2 className="text-4xl md:text-6xl font-serif mb-4 text-cream" data-id="element-281">
          Más los 3 Bonus Estratégicos
        </h2>
        <p className="text-xl md:text-2xl text-dusty-rose font-medium" data-id="element-282">
          Incluidos siempre — sin costo extra
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-283">
        {bonuses.map((bonus, i) => <div key={i} className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-8 relative flex flex-col" data-id="element-284">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-green-500 text-white px-4 py-1 rounded-full text-sm font-bold tracking-wider shadow-lg" data-id="element-285">
              GRATIS
            </div>

            <div className="text-center mb-6 mt-2" data-id="element-286">
              <span className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white/10 mb-4" data-id="element-287">
                <Gift size={32} className="text-gold" data-id="element-288" />
              </span>
              <p className="text-gold font-bold tracking-widest text-sm mb-2" data-id="element-289">
                BONUS {i + 1}
              </p>
              <h3 className="text-2xl font-serif font-bold text-cream" data-id="element-290">
                {bonus.title}
              </h3>
            </div>

            <p className="text-cream/80 text-center leading-relaxed flex-grow mb-6" data-id="element-291">
              {bonus.desc}
            </p>

            <div className="text-center pt-6 border-t border-white/10 mt-auto" data-id="element-292">
              <p className="text-sm text-cream/60 uppercase tracking-wider" data-id="element-293">
                Valor regular
              </p>
              <p className="text-xl font-bold text-cream line-through opacity-70" data-id="element-294">
                {bonus.value}
              </p>
            </div>
          </div>)}
      </div>

      <div className="max-w-2xl mx-auto bg-white text-burgundy rounded-2xl p-8 text-center shadow-xl" data-id="element-295">
        <p className="text-lg font-medium mb-2" data-id="element-296">Valor total de los 3 Bonus:</p>
        <p className="text-3xl font-bold line-through text-text-main/40 mb-4" data-id="element-297">
          Valor real: $42 USD
        </p>
        <div className="inline-block bg-gold text-text-main font-black px-6 py-3 rounded-full text-lg md:text-xl shadow-md" data-id="element-298">
          GRATIS — Incluidos siempre
        </div>
      </div>
    </SectionWrapper>;
}